import React from "react";
import moment from "moment";
import call from "../../../images/common/call.svg";
import { Status, LocaleLink, Icon } from "../../common/";
import I18n from "../../../i18n/I18n";
import CONFIG from "../../../config/";
import Helper from "../../../helper/Helper";
import styles from "./styles.scss";

const DisputeRow = props => {
  const { data, seller } = props;
  return (
    <div>
      <div>
        <LocaleLink to={"/disputes/"} className={styles.backArrow}>
          <Icon name={Helper.getLang() === "ar" ? "fwd-arrow" : "back-arrow"} />
          {data && data.ticket_nr ? (
            <div className={styles.backCtr}>
              <div className={styles.backLabel}>
                {I18n.getText("disputes.ticket-nr")}
              </div>
              <div className={styles.ticketNr}>{data.ticket_nr}</div>
            </div>
          ) : (
            ""
          )}
        </LocaleLink>
      </div>
      <div className={styles.ctr}>
        <div className={styles.header}>
          {data && data.status ? (
            <div className={styles.status}>
              <div className={styles.statusLabel}>
                {I18n.getText("imports.status")}
                :
              </div>
              <Status status={data.status} />
            </div>
          ) : (
            ""
          )}
          {data && data.ticket_nr ? (
            <div className={styles.status}>
              <div className={styles.statusLabel}>
                {I18n.getText("disputes.ticket-nr")}:
              </div>
              <div className={styles.ticketNr}>{data.ticket_nr}</div>
            </div>
          ) : (
            ""
          )}
        </div>
        {data ? (
          <div className={styles.details}>
            <div className={styles.eachDet}>
              <label>
                {I18n.getText(
                  data.dispute_type === "RETURN"
                    ? "disputes.rtv-document"
                    : "disputes.closed-asn"
                )}
              </label>
              <strong className={styles.value}>{data.ref_to}</strong>
            </div>
            {data.dispute_reason ? (
              <div className={styles.eachDet}>
                <label>{I18n.getText("disputes.reason")}</label>
                <div className={styles.value}>
                  <strong>{data.dispute_reason}</strong>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className={styles.eachDet}>
              <label>{I18n.getText("disputes.description")}</label>
              <div className={styles.value}>{data.description}</div>
            </div>
            {data.resolution_amount ? (
              <div className={styles.eachDet}>
                <label>{I18n.getText("disputes.resolution")}</label>
                <div className={styles.value}>
                  <strong>{I18n.getText("disputes.paid")} </strong>{" "}
                  {I18n.formatCurrency(
                    Helper.formatPrice(
                      data.resolution_amount,
                      data.currency_code
                    )
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      {data && data.status === "open" ? (
        <div className={styles.callFooter}>
          <img src={call} alt="call" />
          <p>{I18n.getText("disputes.call-action")}</p>
          <a
            href={`tel: ${
              seller && seller === "SA"
                ? CONFIG.PHONE_NUMBER_KSA
                : CONFIG.PHONE_NUMBER
            }`}
            className={styles.subContact}
          >
            {seller && seller === "SA"
              ? CONFIG.PHONE_NUMBER_KSA
              : CONFIG.PHONE_NUMBER}
          </a>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default DisputeRow;



// WEBPACK FOOTER //
// ./src/components/disputes/disputeDetails/DisputeDetails.js